<template>
  <div class="benefit-cube">
    <slot name="icon" />
    <slot name="header" />
    <slot name="text" />
  </div>
</template>

<script>
export default {
  name: "BenefitCube",
};
</script>

<style lang="scss" scoped></style>
